'use strict';

require('./index').polyfill();



//////////////////
// WEBPACK FOOTER
// ./~/es6-object-assign/auto.js
// module id = 8
// module chunks = 0